var _path, _path2, _path3, _g, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcterGamble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2067_50671)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#6A6F73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37333 23.9929C6.37333 12.9995 13.3133 3.6262 23.0533 0.0195312C10.24 0.519531 0 11.0595 0 23.9995C0 36.9529 10.26 47.5062 23.0933 47.9795C13.34 44.3795 6.37333 34.9995 6.37333 23.9929Z",
    fill: "#6A6F73"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2067_50671",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 48
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37333 23.9929C6.37333 12.9995 13.3133 3.6262 23.0533 0.0195312C10.24 0.519531 0 11.0595 0 23.9995C0 36.9529 10.26 47.5062 23.0933 47.9795C13.34 44.3795 6.37333 34.9995 6.37333 23.9929Z",
    fill: "url(#paint0_radial_2067_50671)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2067_50671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37333 23.9929C6.37333 12.9995 13.3133 3.6262 23.0533 0.0195312C10.24 0.519531 0 11.0595 0 23.9995C0 36.9529 10.26 47.5062 23.0933 47.9795C13.34 44.3795 6.37333 34.9995 6.37333 23.9929Z",
    fill: "#3E4143"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5934 21.716C25.1868 17.7893 22.2068 16.7227 20.2668 16.7227H13.8401C14.3734 17.0893 14.2868 17.576 14.1801 17.876L10.4334 29.8427C10.2868 30.316 9.72676 30.816 9.42676 30.8893H14.6268C14.3401 30.836 13.9334 30.4293 14.0801 29.876L15.4401 25.5493C15.4468 25.5493 21.7001 26.396 23.5934 21.716ZM18.5401 17.8227C19.2201 17.8227 21.1068 17.916 19.8868 21.4827C18.6134 25.2293 15.7868 24.456 15.7868 24.456L17.8668 17.8227H18.5401Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7533 30.8951H31.2533C30.1333 30.5351 28.4799 29.4751 27.8199 28.7218C28.3533 28.1418 29.0133 27.4085 29.1333 25.9218H27.3199C27.3199 25.9218 27.6666 26.1218 27.6666 26.5485C27.6666 26.9418 27.5066 27.4885 27.1999 27.8685C26.6666 27.0818 26.0999 26.1818 25.8999 24.8618C26.6133 24.5085 27.6133 24.1218 28.4066 23.4285C29.1599 22.7685 29.3333 22.1418 29.3466 21.7351V21.6818C29.3466 21.2551 29.1799 20.8551 28.8733 20.5551C28.3466 20.0351 27.5199 19.8218 26.6466 19.9818C25.9466 20.1151 25.3533 20.4885 25.0533 20.7618C23.9999 21.7551 23.8666 23.3885 23.8666 24.1285C23.8666 24.3085 23.8733 24.4418 23.8799 24.5218C23.8199 24.5485 23.7133 24.5885 23.7133 24.5885C22.9399 24.8751 20.8799 25.4218 20.1466 27.1151C20.0533 27.3285 19.9199 27.7951 19.9199 28.3351C19.9199 28.8018 20.0199 29.3218 20.3199 29.7951C20.8399 30.6085 21.7199 31.1218 23.1333 31.0951C24.6666 31.0685 26.1799 30.0218 26.4466 29.8285C26.7066 30.0751 27.3933 30.7218 27.7533 30.8951ZM27.7533 21.4285C27.5733 22.5685 26.0933 23.7218 25.7333 23.8751C25.6666 23.2351 25.6999 22.2218 26.2333 21.3951C26.5866 20.8485 27.0599 20.6085 27.4399 20.7418C27.7466 20.8485 27.7799 21.1285 27.7533 21.4285ZM25.6999 29.0551C25.4933 29.1818 24.6799 29.5951 23.9199 29.6685C23.2133 29.7351 22.0399 29.4618 22.0466 28.0485C22.0466 26.8418 23.3599 25.9551 24.0733 25.6485C24.3599 26.8151 25.0066 28.1351 25.6999 29.0551Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3866 17.8347C40.4666 17.3347 42.18 18.9614 42.3333 19.0747L42.9266 17.1881C42.1066 16.9414 36.14 14.9214 31.92 19.7347C29.3266 22.6947 28.6933 28.7614 31.98 30.3881C35.5 32.1281 39.3866 30.1214 39.6733 29.9814L41.28 24.8614C41.4533 24.2414 41.8466 23.8414 42.54 23.5814H36.9533C37.7666 23.9214 37.7066 24.5347 37.6466 24.7881L36.04 29.9081C35.8266 29.9481 31.3333 31.0681 33.8466 23.2081C34.4 21.5214 35.9133 18.4281 38.3866 17.8347Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2067_50671",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1326 23.2681) rotate(-88.2324) scale(25.8488 26.3042)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2067_50671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcterGamble);
export default __webpack_public_path__ + "static/media/procter_gamble.5dbfd0665f58d6507eceab5d2cd6891c.svg";
export { ForwardRef as ReactComponent };